import { Link } from "react-router-dom";

const Faq = () => {
  return (
    <>
      <div className="inner-banner before-none bg-white border-top">
        <div className="container">
          <div className="inner-banner-txt">
            <nav aria-label="breadcrumb" className="breadcrumb-nav">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  FAQ's{" "}
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <section className="main-section faq-page border-bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-sm-12 col-xs-12">
              <div className="main-title wow fadeInUp mb-5">
                <h1 className="fs-35 wow fadeInUp fadeIn">FAQ's </h1>
              </div>
              <div
                className="accordion md-accordion"
                id="accordionEx"
                role="tablist"
                aria-multiselectable="true"
              >
                <div className="card">
                  <div className="card-header" role="tab" id="headingOne1">
                    <a
                      data-toggle="collapse"
                      data-parent="#accordionEx"
                      href="#collapseOne1"
                      aria-expanded="true"
                      aria-controls="collapseOne1"
                    >
                      <h5 className="mb-0">
                        Do I need to make an account before placing an order?{" "}
                        <i className="lnr lnr-chevron-down" />
                      </h5>
                    </a>
                  </div>
                  <div
                    id="collapseOne1"
                    className="collapse show"
                    role="tabpanel"
                    aria-labelledby="headingOne1"
                    data-parent="#accordionEx"
                  >
                    <div className="card-body">
                      Dummy text Ipsum is basically fake text of the printing
                      and typesetting industry. Lorem Ipsum has been the
                      business' standard faker text since the 1500s, when an
                      obscure printer took a kitchen of type and blended it to
                      make a sort model book. It has endure five centuries, yet
                      in addition the jump into electronic typesetting,
                      remaining basically unaltered. It was popularised in the
                      1960s with the release of Letraset sheets containing Lorem
                      Ipsum passages, and more recently with desktop publishing
                      software like Aldus PageMaker including versions of Lorem
                      Ipsum.
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-header" role="tab" id="headingTwo2">
                    <a
                      className="collapsed"
                      data-toggle="collapse"
                      data-parent="#accordionEx"
                      href="#collapseTwo2"
                      aria-expanded="false"
                      aria-controls="collapseTwo2"
                    >
                      <h5 className="mb-0">
                        How do I sign up to receive emails or messages from
                        Dress Up? <i className="lnr lnr-chevron-down" />
                      </h5>
                    </a>
                  </div>
                  <div
                    id="collapseTwo2"
                    className="collapse"
                    role="tabpanel"
                    aria-labelledby="headingTwo2"
                    data-parent="#accordionEx"
                  >
                    <div className="card-body">
                      Dummy text Ipsum is basically fake text of the printing
                      and typesetting industry. Lorem Ipsum has been the
                      business' standard faker text since the 1500s, when an
                      obscure printer took a kitchen of type and blended it to
                      make a sort model book. It has endure five centuries, yet
                      in addition the jump into electronic typesetting,
                      remaining basically unaltered. It was popularised in the
                      1960s with the release of Letraset sheets containing Lorem
                      Ipsum passages, and more recently with desktop publishing
                      software like Aldus PageMaker including versions of Lorem
                      Ipsum.
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-header" role="tab" id="headingTwo3">
                    <a
                      className="collapsed"
                      data-toggle="collapse"
                      data-parent="#accordionEx"
                      href="#collapseTwo3"
                      aria-expanded="false"
                      aria-controls="collapseTwo3"
                    >
                      <h5 className="mb-0">
                        How can cancel or change my order?{" "}
                        <i className="lnr lnr-chevron-down" />
                      </h5>
                    </a>
                  </div>
                  <div
                    id="collapseTwo3"
                    className="collapse"
                    role="tabpanel"
                    aria-labelledby="headingTwo3"
                    data-parent="#accordionEx"
                  >
                    <div className="card-body">
                      Dummy text Ipsum is basically fake text of the printing
                      and typesetting industry. Lorem Ipsum has been the
                      business' standard faker text since the 1500s, when an
                      obscure printer took a kitchen of type and blended it to
                      make a sort model book. It has endure five centuries, yet
                      in addition the jump into electronic typesetting,
                      remaining basically unaltered. It was popularised in the
                      1960s with the release of Letraset sheets containing Lorem
                      Ipsum passages, and more recently with desktop publishing
                      software like Aldus PageMaker including versions of Lorem
                      Ipsum.
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-header" role="tab" id="headingTwo4">
                    <a
                      className="collapsed"
                      data-toggle="collapse"
                      data-parent="#accordionEx"
                      href="#collapseTwo4"
                      aria-expanded="false"
                      aria-controls="collapseTwo4"
                    >
                      <h5 className="mb-0">
                        What payments are accepted?{" "}
                        <i className="lnr lnr-chevron-down" />
                      </h5>
                    </a>
                  </div>
                  <div
                    id="collapseTwo4"
                    className="collapse"
                    role="tabpanel"
                    aria-labelledby="headingTwo4"
                    data-parent="#accordionEx"
                  >
                    <div className="card-body">
                      Dummy text Ipsum is basically fake text of the printing
                      and typesetting industry. Lorem Ipsum has been the
                      business' standard faker text since the 1500s, when an
                      obscure printer took a kitchen of type and blended it to
                      make a sort model book. It has endure five centuries, yet
                      in addition the jump into electronic typesetting,
                      remaining basically unaltered. It was popularised in the
                      1960s with the release of Letraset sheets containing Lorem
                      Ipsum passages, and more recently with desktop publishing
                      software like Aldus PageMaker including versions of Lorem
                      Ipsum.
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-header" role="tab" id="headingTwo5">
                    <a
                      className="collapsed"
                      data-toggle="collapse"
                      data-parent="#accordionEx"
                      href="#collapseTwo5"
                      aria-expanded="false"
                      aria-controls="collapseTwo5"
                    >
                      <h5 className="mb-0">
                        Payments are secured !
                        <i className="lnr lnr-chevron-down" />
                      </h5>
                    </a>
                  </div>
                  <div
                    id="collapseTwo5"
                    className="collapse"
                    role="tabpanel"
                    aria-labelledby="headingTwo5"
                    data-parent="#accordionEx"
                  >
                    <div className="card-body">
                      Dummy text Ipsum is basically fake text of the printing
                      and typesetting industry. Lorem Ipsum has been the
                      business' standard faker text since the 1500s, when an
                      obscure printer took a kitchen of type and blended it to
                      make a sort model book. It has endure five centuries, yet
                      in addition the jump into electronic typesetting,
                      remaining basically unaltered. It was popularised in the
                      1960s with the release of Letraset sheets containing Lorem
                      Ipsum passages, and more recently with desktop publishing
                      software like Aldus PageMaker including versions of Lorem
                      Ipsum.
                    </div>
                  </div>
                </div>
                <div className="card-header" role="tab" id="headingTwo6">
                  <a
                    className="collapsed"
                    data-toggle="collapse"
                    data-parent="#accordionEx"
                    href="#collapseTwo6"
                    aria-expanded="false"
                    aria-controls="collapseTwo6"
                  >
                    <h5 className="mb-0">
                      Customer Support
                      <i className="lnr lnr-chevron-down" />
                    </h5>
                  </a>
                </div>
                <div
                  id="collapseTwo6"
                  className="collapse"
                  role="tabpanel"
                  aria-labelledby="headingTwo6"
                  data-parent="#accordionEx"
                >
                  <div className="card-body">
                    <p className="mb-0">
                      Our team is happy to answer any questions. For assistance,
                      check out our{" "}
                      <a href="#ask-question" className="link">
                        FAQ
                      </a>{" "}
                      or{" "}
                      <a href="emailtto:contact@gmail.com" className="link">
                        e-mail us
                      </a>
                      . We’re always here to help.{" "}
                      <a href="tel:+91 9991111025" className="link">
                        Call
                      </a>
                    </p>
                  </div>
                </div>
              </div>
              <div className=" pt-3 mt-5" id="ask-question">
                <a
                  href="#ask-question"
                  data-toggle="modal"
                  data-target="#ask-quest"
                  className="btn ascroll"
                >
                  <span> Ask A Question</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* main section */}
      {/* Modal */}
      <div
        className="modal fade"
        id="ask-quest"
        tabIndex={-1}
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h2 className="modal-title" id="exampleModalLongTitle">
                Ask A Question
              </h2>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">
                  <i className="lni lni-close" />
                </span>
              </button>
            </div>
            <div className="modal-body">
              <form method="post" action="#">
                <div className="field">
                  <label>Your Query</label>
                  <input
                    type="text"
                    name="questions-title"
                    className="form-control"
                  />
                </div>
                <div className="field">
                  <label>Message</label>
                  <textarea
                    name="message"
                    rows={4}
                    className="form-control"
                    defaultValue={""}
                  />
                </div>
                <div className="field">
                  <button>Post Question</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Faq;
